import { render } from "./CommonAuthorSix.vue?vue&type=template&id=0e7ef28c&scoped=true"
import script from "./CommonAuthorSix.vue?vue&type=script&lang=js"
export * from "./CommonAuthorSix.vue?vue&type=script&lang=js"

import "./CommonAuthorSix.vue?vue&type=style&index=0&id=0e7ef28c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7ef28c"]])

export default __exports__